import { GeneralService } from '../../shared/services/general.service';
import { Injectable } from '@angular/core';

@Injectable()
export class DefaultIntl {
    constructor(private generalService: GeneralService) {}
    cancelBtnLabel = this.translate('Cancel');
    setBtnLabel = this.translate('Search');

    translate(val: string): string {
        return this.generalService.translate.instant(val);
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/defaultIntl.ts